<template>
  <div>
    <div v-if="$store.state.step === 7" class="text-center">
      <h4>Complete!</h4>
      <h6 class="secondary">
        Review your video.
      </h6>
      <div style="80%">
        <video
          width="640"
          height="380"
          controls
          source
          :src="customVideo"
          type="video/mp4"
          @ended="onEnd()"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    <b-modal class="text-center d-flex" id="confirm-delete-7" hide-footer>
      <h3 class="mt-4 text-center">ARE YOU SURE?</h3>
      <h6 class="mt-4 text-center">
        Going back will start the personalization process over. Your video will
        be deleted. Are you sure you want to proceed?
      </h6>
      <h6 class="mt-4 text-center">
        This action cannot be undone
      </h6>
      <div class="text-center pb-4">
        <b-button
          id="yes"
          type="button"
          variant="outline-primary"
          class="mt-4 mr-3 outline"
          @click.prevent="deleting()"
        >
          <span>YES</span>
        </b-button>
        <b-button
          id="no"
          type="button"
          variant="outline-primary"
          class="mt-4 outline"
          @click.prevent="hideConfirmation()"
        >
          <span>NO</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "StepSeven",
  props: ["step"],
  mounted() {},
  computed: {
    srcVid: {
      get() {
        return this.$store.state.customization.srcVid;
      },
    },
    video: {
      get() {
        return this.$store.state.srcVideos.find(
          (x) => x.id === this.$store.state.customVideo
        );
      },
    },
    mostRecentVideo: {
      get() {
        return this.$store.state.videos[this.srcVid][0];
      },
    },
    nextStep: {
      // stepNav nolds the setter for this
      get() {
        return this.$store.state.nextStep;
      },
    },
    customVideo: {
      get() {
        //remove crazy double "" in the db /// REFACTOR!!!
        return (
          "https://drive.google.com/uc?export=download&id=" +
          this.mostRecentVideo.customVideo.slice(1, -1)
        );
      },
    },
  },
  data: function() {
    return {
      no_headshot: "https://i.imgur.com/Gcvs580m.png",
      //customVideo: this.mostRecentVideo.customVideo.slice(1, -1),
    };
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 8);
    },
    prev() {
      this.$store.commit("changeStep", 6);
    },
    onEnd: function() {
      this.$bvModal.show("video-ended");
    },
    deleting: function() {
      // removes most recent video when the user confirms they want to
      // delete created video and go back to steps 1-4
      this.$root.$refs.App.deleteVideo(this.mostRecentVideo);
      this.$bvModal.hide("confirm-delete-7");
      this.$store.commit("changeStep", this.nextStep);
    },
    hideConfirmation: function() {
      this.$bvModal.hide("confirm-delete-7");
    },
  },
};
</script>
